import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
export default {
  uploadUrl: process.env.VUE_APP_API_BASE_URL + '/upload',
  uploadImgUrl: process.env.VUE_APP_API_BASE_URL + '/upload/img',
  /**
   * 抽屉的样式
   */
  drawerStyle: {
    height: 'calc(100% - 55px)',
    overflow: 'auto',
    paddingBottom: '53px',
    position: 'static'
  },
  formRule: {
    required: function required() {
      var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'blur';
      return {
        required: true,
        message: "\u8BF7\u8F93\u5165".concat(label),
        trigger: trigger
      };
    },
    max: function max() {
      var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var _max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number;
      var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
      return {
        min: 1,
        max: _max,
        message: "".concat(label, "\u6700\u591A").concat(_max, "\u4E2A\u5B57\u7B26"),
        trigger: trigger
      };
    },
    min: function min() {
      var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var _min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number;
      var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
      return {
        min: _min,
        message: "".concat(label, "\u6700\u5C11").concat(_min, "\u4E2A\u5B57\u7B26"),
        trigger: trigger
      };
    },
    email: function email() {
      var trigger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'change';
      return {
        type: 'email',
        message: '输入的邮箱格式不正确！',
        trigger: trigger
      };
    },
    mobile: function mobile() {
      var trigger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'change';
      return {
        pattern: /^((13)|(14)|(15)|(16)|(17)|(18)|(19))\d{9}$/,
        message: '输入的手机号码格式不正确！',
        trigger: trigger
      };
    }
  }
};